import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Utils } from '../utils';
import { SeoPageDetail } from '../seo-page/seo-page.models';

@Injectable({ providedIn: 'root' })
export class SeoPageService {
  constructor(private readonly http: HttpClient) {}

  public detail(slug: string): Observable<SeoPageDetail> {
    const base = Utils.getApiUrl();
    return this.http.get<SeoPageDetail>(`${base}/seo-pages/${encodeURIComponent(slug)}`);
  }

  public slugs(): Observable<{ slugs: string[] }> {
    const base = Utils.getApiUrl();
    return this.http.get<{ slugs: string[] }>(`${base}/seo-pages/slugs`);
  }
}
